/**
 * The operator's own recent lookups, in this browser only (localStorage).
 * Never server-side: these are customer email addresses, and they belong to one
 * person's session, not to the account.
 */
const KEY = "admin:users:recent";
const MAX = 8;

export interface RecentLookup {
  email: string;
  at: string;
}

export function readRecent(): RecentLookup[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (r): r is RecentLookup =>
        typeof r?.email === "string" && typeof r?.at === "string"
    );
  } catch {
    // Private window, blocked storage, or corrupt JSON — an empty list is fine.
    return [];
  }
}

export function pushRecent(email: string): RecentLookup[] {
  const next = [
    { email, at: new Date().toISOString() },
    ...readRecent().filter((r) => r.email !== email),
  ].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Nothing to do — the list is a convenience, not state we depend on.
  }
  return next;
}

export function clearRecent(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* see above */
  }
}

